import React from 'react'
import Layout from '../layout'
import Contact from '../screens/Contact'

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <Contact />
  </Layout>
)

export default IndexPage
